export default __webpack_public_path__ + "static/media/EngineeringRoads_03.4055b1e4.png";